import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../webcomponents.constants';
import { NetworkTreeDataProvider } from '../dataProvider/NetworkTreeDataProvider';

export class NetworkTreeDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, NetworkTreeDataProvider);
  }
}
